module.exports = __webpack_public_path__ + "img/sidePic.9326558a.png";